import keyMirror from 'keymirror';

export const RoofsSelectorMapActionTypes = keyMirror({
  SET_MAP_CENTER: undefined,
  FETCH_ZIP_CODE_AND_ADDRESS_BY_LAT_LNG: undefined,
  SET_LOCATION: undefined,
  SET_MAP_ZOOM: undefined,
  GET_ADDRESS_BY_ZIP: undefined,
});
